import React from 'react'

const Home = () => {
    return (
        <div className='faqra-club-section'>
            <section>
                <div className='faqra-club-section-content'>
                    <h1>Under Construction</h1>
                    <div className='sub-heading'>
                        <span>Stay Tuned</span>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default Home
